export const isOneOf = <EnumType>(enumeration: EnumType, value: any): boolean => {
  const values: any[] = Object.values(enumeration);
  return values.some((enumValue) => value === enumValue);
};
